// Step 3 — Order created, pay via M-Pesa STK Push.

import { ArrowLeft, Check, Loader2, ShieldCheck, Smartphone } from "lucide-react";
import { ksh } from "@/lib/api";
import { ORDER } from "@/constants/testIds";
import { Field } from "./_shared";

export function OrderStep3Pay({
  order,
  mpesaConfig,
  total,
  payPhone, setPayPhone,
  paying, initiatePay,
  confirming, confirmPayment,
  trackCopied, copyTracking,
  goBack,
}) {
  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#525252] mb-2">Order created</div>
          <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter mb-2">Pay with M-Pesa</h1>
        </div>
        <button
          type="button"
          onClick={goBack}
          data-testid="back-to-details"
          className="px-4 py-2 text-xs uppercase tracking-[0.2em] font-bold border-2 border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors inline-flex items-center gap-2"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Edit details
        </button>
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-[#525252] text-sm">Tracking number:</span>
        <button
          onClick={copyTracking}
          data-testid="copy-tracking-number"
          className={`mono font-bold text-base px-3 py-1.5 border-2 inline-flex items-center gap-2 transition-colors ${trackCopied ? "border-[#059669] bg-[#059669]/10 text-[#059669]" : "border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white"}`}
        >
          {order.tracking_number}
          {trackCopied ? <Check className="w-4 h-4" strokeWidth={3} /> : <ShieldCheck className="w-4 h-4" strokeWidth={2} />}
        </button>
        <span className="text-[10px] uppercase tracking-[0.2em] text-[#525252]">{trackCopied ? "Copied!" : "Click to copy"}</span>
      </div>

      {mpesaConfig?.placeholder_mode && (
        <div className="border-2 border-[#F59E0B] bg-[#F59E0B]/10 p-4 text-sm">
          <strong className="uppercase tracking-[0.15em] text-xs">Test mode</strong> · M-Pesa credentials are not configured, so payment will be simulated. No real money will be charged. Add Daraja credentials in <code className="mono text-xs">backend/.env</code> to enable real STK push.
        </div>
      )}

      <div className="bg-white border border-[#0A0A0A] p-6">
        <div className="flex items-center gap-3 mb-6 pb-6 border-b border-[#E5E5E5]">
          <div className="w-12 h-12 bg-[#059669] flex items-center justify-center">
            <Smartphone className="w-6 h-6 text-white" strokeWidth={2.5} />
          </div>
          <div>
            <div className="font-display font-bold text-xl">M-Pesa STK Push</div>
            <div className="text-xs text-[#525252]">You&apos;ll receive a prompt on your phone</div>
          </div>
        </div>

        <Field label="M-Pesa phone number">
          <input
            data-testid={ORDER.payPhone}
            value={payPhone}
            onChange={(e) => setPayPhone(e.target.value)}
            placeholder="07XXXXXXXX"
            className="w-full px-4 py-4 border border-[#E5E5E5] focus:border-[#0A0A0A] outline-none mono text-lg"
          />
        </Field>

        <div className="mt-6">
          <button
            data-testid={ORDER.payConfirm}
            onClick={initiatePay}
            disabled={paying}
            className="w-full bg-[#059669] text-white px-8 py-5 text-sm uppercase tracking-[0.2em] font-bold hover:bg-[#047857] transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2"
          >
            {paying ? <Loader2 className="w-4 h-4 animate-spin" /> : <ShieldCheck className="w-4 h-4" />}
            Pay {ksh(total)} now
          </button>
        </div>

        <div className="mt-3">
          <button
            data-testid="confirm-payment-btn"
            onClick={confirmPayment}
            disabled={confirming}
            className="w-full bg-white text-[#0A0A0A] px-8 py-4 text-sm uppercase tracking-[0.2em] font-bold border-2 border-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white transition-colors disabled:opacity-50 inline-flex items-center justify-center gap-2"
          >
            {confirming ? <Loader2 className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
            Already paid? Confirm payment
          </button>
          <p className="mt-2 text-[11px] text-[#525252] text-center">
            Tap this if you&apos;ve completed the M-Pesa PIN but the page hasn&apos;t updated.
          </p>
        </div>

        <div className="mt-4 flex items-center gap-2 text-xs text-[#525252]">
          <ShieldCheck className="w-4 h-4 text-[#059669]" />
          Secure payment via Safaricom Daraja
        </div>
      </div>
    </div>
  );
}
